import { useEffect, useRef, useState } from "react";
import "./style.css";
import {
  getAutocompleteAddresses,
  getLocationByPlaceid,
} from "../../../actions/googleAPI";
import AirportLogoMaps from "../../../images/airport-logo-maps.svg";
import PointLogoMaps from "../../../images/point-logo-maps.svg";
import StationLogoMaps from "../../../images/station-logo-maps.svg";
import HotelLogoMaps from "../../../images/hotel-logo-maps.svg";
import RestaurantLogoMaps from "../../../images/restaurant-logo-maps.svg";

const AdminInputLocation = ({
  type = "text",
  prefixIcon = null,
  suffixIcon = null,
  placeholder = "",
  mb = "mb-3",
  onSelectLocation,
  name = "",
  label = null,
  hasIndex = false,
  index = null,
  value = "",
  disabled = false,
}) => {
  const [locationText, setLocationText] = useState(value || "");
  const [locations, setLocations] = useState([]);

  const debounceTimer = useRef(null);

  useEffect(() => {
    setLocationText(value || "");
  }, [value]);

  const handleOnChange = async (val) => {
    setLocationText(val);

    // Clear debounce timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // If empty, clear results immediately
    if (val.trim().length === 0) {
      setLocations([]);
      return;
    }

    // Debounce API search
    debounceTimer.current = setTimeout(async () => {
      const resp = await getAutocompleteAddresses(val);
      setLocations(resp || []);
    }, 350);
  };

  const handleSelectLocation = async (location) => {
    // Cancel any pending debounce calls
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    let detail = await getLocationByPlaceid(location.place_id);
    detail.name = location?.structured_formatting?.main_text;
    detail.description = location.description;

    if (hasIndex) onSelectLocation(detail, index);
    else onSelectLocation(detail);

    setLocationText(location.structured_formatting.main_text);
    setLocations([]);  // Close dropdown immediately
  };

  return (
    <>
      <div className={`${mb} position-relative`}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}

        <div className="w-100 rounded border">
          <div className="tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 input-container">
            {prefixIcon && <span className="ms-3">{prefixIcon}</span>}

            <input
              className={`
                tw:!border-none 
                tw:!outline-none 
                tw:!w-full 
                tw:!leading-[32px] 
                tw:rounded 
                tw:border-0 
                tw:py-2 
                tw:!text-[15px] 
                tw:!font-['Hanken_Grotesk'] 
                tw:placeholder:!text-[15px] 
                tw:placeholder:!font-['Hanken_Grotesk'] 
                no-calendar 
                ${prefixIcon ? "" : "px-3"}
              `}
              type={type}
              placeholder={placeholder}
              value={locationText}
              onChange={(e) => handleOnChange(e.target.value)}
              disabled={disabled}
            />

            {suffixIcon && <span className="me-3">{suffixIcon}</span>}
          </div>
        </div>
      </div>

      {locations.length > 0 && (
        <div
          style={{
            position: "absolute",
            backgroundColor: "white",
            zIndex: 1000,
            maxHeight: "205px",
            overflow: "auto",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          {locations.map((item, index) => (
            <div key={index}>
              <div
                className="d-flex border-bottom hover pointer px-3 gap-3"
                onClick={() => handleSelectLocation(item)}
              >
                <img
                  src={
                    item.types.includes("airport")
                      ? AirportLogoMaps
                      : item.types.includes("lodging")
                        ? HotelLogoMaps
                        : item.types.includes("train_station")
                          ? StationLogoMaps
                          : item.types.includes("restaurant")
                            ? RestaurantLogoMaps
                            : PointLogoMaps
                  }
                  alt="icon"
                />
                <div className="py-2">
                  <p className="m-0 fw-bold">
                    {item.structured_formatting.main_text}
                  </p>
                  <small className="fs-13">
                    {item.structured_formatting.secondary_text}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AdminInputLocation;
